/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeNotificationChannel } from './EmployeeNotificationChannel';
import {
    EmployeeNotificationChannelFromJSON,
    EmployeeNotificationChannelFromJSONTyped,
    EmployeeNotificationChannelToJSON,
    EmployeeNotificationChannelToJSONTyped,
} from './EmployeeNotificationChannel';

/**
 * 
 * @export
 * @interface ListEmployeeNotificationChannelsResponse
 */
export interface ListEmployeeNotificationChannelsResponse {
    /**
     * 
     * @type {Array<EmployeeNotificationChannel>}
     * @memberof ListEmployeeNotificationChannelsResponse
     */
    data: Array<EmployeeNotificationChannel>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeNotificationChannelsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeNotificationChannelsResponse interface.
 */
export function instanceOfListEmployeeNotificationChannelsResponse(value: object): value is ListEmployeeNotificationChannelsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeNotificationChannelsResponseFromJSON(json: any): ListEmployeeNotificationChannelsResponse {
    return ListEmployeeNotificationChannelsResponseFromJSONTyped(json, false);
}

export function ListEmployeeNotificationChannelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeNotificationChannelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeNotificationChannelFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeNotificationChannelsResponseToJSON(json: any): ListEmployeeNotificationChannelsResponse {
      return ListEmployeeNotificationChannelsResponseToJSONTyped(json, false);
  }

  export function ListEmployeeNotificationChannelsResponseToJSONTyped(value?: ListEmployeeNotificationChannelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeNotificationChannelToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

